export const SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND';
export const ACCESS_DENIED = 'ACCESS_DENIED';
export const NOT_FOUND = 'NOT_FOUND';
export const LIMIT_MEMBERS = 'LIMIT_MEMBERS';
export const INVALID_INVITATION_CODE = 'INVALID_INVITATION_CODE';
export const VALIDATION_ERROR = 'ValidationError';
